export const introduce = {
  text: '持币余额 100-1k 的地址数量',
  height: 1200,
};
